import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CategoryEntity } from './category.entity';
import { PriceContractEntity } from './price-contract.entity';

@Index('fk_category__id', ['fkCategoryId'], {})
@Index('fk_price_contract__id', ['fkPriceContractId'], {})
@Entity('price_contract_category_client')
export class PriceContractCategoryClientEntity extends BaseEntity {
	@Column('int', { name: 'fk_price_contract__id', unsigned: true })
	public fkPriceContractId!: number;

	@Column('int', { name: 'fk_category__id', unsigned: true })
	public fkCategoryId!: number;

	@ManyToOne(
		() => CategoryEntity,
		(category) => category.priceContractCategoryClients,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: 'fk_category__id', referencedColumnName: 'id' }])
	public category!: CategoryEntity;

	@ManyToOne(
		() => PriceContractEntity,
		(priceContract) => priceContract.priceContractCategoryClients,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: 'fk_price_contract__id', referencedColumnName: 'id' }])
	public priceContract!: PriceContractEntity;
}
